<template>
  <metainfo />
  <LayoutHeader />
  <router-view />
  <LayoutFooter />
</template>

<script setup>
import { onMounted, onUnmounted, ref, provide } from 'vue'

import LayoutHeader from '@/components/layouts/LayoutHeader.vue'
import LayoutFooter from '@/components/layouts/LayoutFooter.vue'
import 'swiper/css'

const mobileCheck = ref(window.innerWidth <= 767)

const handleResize = () => {
  mobileCheck.value = window.innerWidth <= 767
}

onMounted(() => {
  window.addEventListener('resize', handleResize)
})

onUnmounted(() => {
  window.removeEventListener('resize', handleResize)
})

provide('mobileCheck', mobileCheck)
</script>

<style lang="scss">
@import '~@/assets/styles/common.scss';
@import '~@/assets/styles/format.scss';
</style>
